import React from 'react';
import SelectStepTemplate from '../../../template/SelectStepTemplate';
import useGetMateriais, {
  buildOutrosAviamentos,
  buildOutrosTecidos,
} from '../../../template/UseGetMateriais';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import { CancelamentoOPFaltaMPObservacaoStep } from './CancelamentoOPFaltaMPObservacaoStep';

export const CancelamentoOPFaltaMP: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais();
  const newMateriais = [
    ...materiais,
    buildOutrosTecidos(),
    buildOutrosAviamentos(),
  ];

  const stepNumber = '2';
  const stepSubTitle = 'Selecione o material.';
  const stepTitle = 'Qual material será cancelado?';
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={CancelamentoOPFaltaMPObservacaoStep as TipoDivergenciaComponent}
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey='materiais'
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};
